var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOutage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Power_Outage"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Power_Outage",
    "data-name": "Power Outage",
    clipPath: "url(#clip-Power_Outage)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-flash_4188096",
    transform: "translate(2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M72.358,11.494l-3.751,6.669a36.032,36.032,0,0,1,7.5,51.685L25.674,19a33.645,33.645,0,0,1,11.462-6.044L41.513,4.2A43.769,43.769,0,0,0,20.464,81.728L23.8,74.642a36.273,36.273,0,0,1-4.377-49.393L69.857,76.1a35.535,35.535,0,0,1-22.091,7.711,32.719,32.719,0,0,1-10.212-1.459l-5.21,6.252a47.011,47.011,0,0,0,15.422,2.709A43.76,43.76,0,0,0,91.531,47.549,43.05,43.05,0,0,0,72.358,11.494Z",
    transform: "translate(0 3.469)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M27.155,30.562,17.985,21.6,13.4,30.562Z",
    transform: "translate(10.19 22.332)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M31.77,26.8,10.929,72.441c-.208.417.208.834.625.417L41.982,37.22Z",
    transform: "translate(7.451 27.969)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M43.984,51.643,55.029,38.722H36.9L58.364,1H32.938L19.6,27.468Z",
    transform: "translate(16.912 0)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOutage);
export default __webpack_public_path__ + "static/media/power-outage.9292e3827f96927187489a2118292d6b.svg";
export { ForwardRef as ReactComponent };